/**
 * Auth utility — always use Bearer token from localStorage.
 * NEVER use withCredentials: true.
 * The platform ingress always sets Access-Control-Allow-Origin: *
 * which the browser blocks for credentialed cross-origin requests.
 */

export const getAuthConfig = (extra = {}) => {
  const token = localStorage.getItem('bluecrate_session_token');
  return token
    ? { headers: { Authorization: `Bearer ${token}` }, ...extra }
    : extra;
};

export const clearAuth = () => {
  localStorage.removeItem('bluecrate_session_token');
  localStorage.removeItem('bluecrate_user');
};

export const getStoredUser = () => {
  try {
    const u = localStorage.getItem('bluecrate_user');
    return u ? JSON.parse(u) : null;
  } catch {
    return null;
  }
};
